module.exports = __webpack_public_path__ + "static/media/gymnase_casalis.8e356db8.jpg";